import { z } from "zod";

/**
 * AI-CONSENT-SCREEN (@UC0459 · QĐ người dùng 21/10/2026 — Apple 5.1.1(i)/5.1.2(i)) — `GET` / `PUT /v1/ai/data-consent`.
 * Contract của trợ lý v2 (ADR-0009 — sau sunset v1 US-AIV2-0002), không phải contract v1 hồi sinh.
 *
 * `providers` là tên riêng nhà cung cấp do SERVER gửi (nguồn: `AI_DATA_CONSENT_PROVIDERS` ở packages/domain) — app không tự ghi cứng, nên
 * đổi nhà cung cấp chỉ cần tăng `version` ở domain. `PUT` mang đúng `version` app đã HIỂN THỊ: lệch phiên bản hiện tại ⇒ 409
 * `AI_DATA_CONSENT_VERSION_STALE` (người dùng chưa thấy nội dung mới thì không được tính là đã đồng ý nội dung mới).
 */
export const AI_DATA_CONSENT_ERROR_CODES = Object.freeze({
  /** Lượt gõ chữ của người chưa đồng ý phiên bản hiện tại — 0 lời gọi LLM. */
  REQUIRED: "AI_DATA_CONSENT_REQUIRED",
  /** `PUT` mang phiên bản khác phiên bản hiện tại. */
  VERSION_STALE: "AI_DATA_CONSENT_VERSION_STALE",
  /**
   * @UC0462 (QĐ người dùng 22/10) — `PUT` ĐỒNG Ý mà câu chữ client hiển thị (`contentVersion`) không phải phiên bản hiện tại, hoặc client không
   * gửi trường này (bản app cũ chép lại `version` của server). Không ghi dòng nào: người chưa thấy nội dung mới không được tính là đã đồng ý
   * nội dung mới. App mới ⇒ «cập nhật ứng dụng để xem nội dung mới».
   */
  CONTENT_OUTDATED: "AI_DATA_CONSENT_CONTENT_OUTDATED",
} as const);

export const aiDataConsentResponseSchema = z
  .object({
    version: z.number().int().positive(),
    granted: z.boolean(),
    providers: z.array(z.string().min(1)).min(1),
    /** Người nhận ẢNH khi quét danh sách thành viên (Google Cloud Vision) — cùng một lựa chọn đồng ý gác cả quét ảnh. */
    imageProviders: z.array(z.string().min(1)).min(1),
    decidedAt: z.string().datetime().nullable(),
  })
  .strict();

export const aiDataConsentUpdateSchema = z
  .object({
    version: z.number().int().positive(),
    /**
     * Phiên bản CÂU CHỮ mà chính bản client đã hiển thị (hằng biên dịch cùng ARB — không chép từ `version` server trả). BẮT BUỘC đúng phiên
     * bản hiện tại khi `granted: true`; tuỳ chọn khi rút đồng ý (app cũ vẫn phải rút được). @UC0462.
     */
    contentVersion: z.number().int().positive().optional(),
    granted: z.boolean(),
  })
  .strict();

export type AiDataConsentResponse = z.infer<typeof aiDataConsentResponseSchema>;
export type AiDataConsentUpdate = z.infer<typeof aiDataConsentUpdateSchema>;
